import * as React from 'react';

import { capitalize } from 'lodash';

export const titleize = (input: string) =>
  input
    .split(/[\s|:|_]+/)
    .map(capitalize)
    .join(' ');

export const Titleize: React.FC<{
  text: string;
}> = ({ text }: { text: string }) => <>{titleize(text)}</>;
